import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <small class="created-by text-muted"><b><a href="" target="_blank" class="text-warning"> NetSul Internet ©</a></b> 2019</small>
  `,
})
export class FooterComponent {
}



// WEBPACK FOOTER //
// /var/www/minha-netsul/src/app/@theme/components/footer/footer.component.ts